import Route from "../../../router/Route";
import { RouterView } from "vue-router";

import RuleEngineIndex from "../pages/RuleEngineIndex.vue";
import RuleEngineModelVersions from "../pages/RuleEngineModelVersions.vue";
import RuleEngineModelVersionsComparison from "../pages/RuleEngineModelVersionsComparison.vue";
import RuleEngineBuilder from "../pages/RuleEngineBuilder.vue";

export default new Route("ruleEngine", "/rule-engine", RouterView, [
	new Route("pricingEngine.index", "", RuleEngineIndex, []),
	new Route(
		"pricingEngine.versions",
		"versions/:model_uuid",
		RuleEngineModelVersions,
		[]
	),
	new Route(
		"pricingEngine.versions.compare",
		"versions/:model_uuid/comparison",
		RuleEngineModelVersionsComparison,
		[]
	),
	new Route(
		"pricingEngine.builder",
		"builder/:model_uuid/:version_uuid/:displayed_ruleset_uuid?",
		RuleEngineBuilder,
		[]
	),
]);
